import React, { Fragment } from 'react';
import { Pagination } from 'antd';
import { createRoot } from 'react-dom/client';
import _urlUtis from '../../utils/url.util';

const LisaPagination = ({ currentPage, pageSize, total }) => {
    const onChange = (page) => {
        _urlUtis.insertParam('page', page);
    };
    return (
        <Fragment>
            {total <= pageSize ? null : (
                <div className="text-center">
                    <Pagination
                        current={currentPage}
                        defaultPageSize={pageSize}
                        total={total}
                        onChange={onChange}
                        showSizeChanger={false}
                    />
                </div>
            )}
        </Fragment>
    );
};

export default LisaPagination;

document.querySelectorAll('react-pagination').forEach((domContainer) => {
    const root = createRoot(domContainer);
    const total = +domContainer.dataset.total;
    const currentPage = +domContainer.dataset.currentPage;
    const pageSize = +domContainer.dataset.pageSize;
    root.render(
        <LisaPagination
            total={total}
            currentPage={currentPage}
            pageSize={pageSize}
        />
    );
});
